<div class="flex items-center gap-1.5">
  <ion-img [src]="'/assets/images/pdf.svg'" class="w-10 h-auto" />
  <span class="font-mono text-sm text-muted">{{ fileSize() }}</span>
</div>
<ion-icon name="open-outline" class="p-2 text-lg" />
